import { Ioption } from 'tradevan-ui/type';
import { EnumDownloadType, EnumExportItemList } from 'view/Layout/enum';
import { IexportItemList } from 'view/Layout/type';

export const getOrderQueryDownloadOption = (
  exportItemList: IexportItemList,
): Ioption[] => {
  const temp = [
    {
      value: EnumDownloadType.報表下載,
      label: '報表下載',
      show: exportItemList[EnumExportItemList.rptDefault],
    },
    {
      value: EnumDownloadType.批次預覽,
      label: '批次預覽',
      show: exportItemList[EnumExportItemList.previewDefault],
    },
    {
      value: EnumDownloadType.文字檔下載,
      label: '文字檔下載',
      show: exportItemList[EnumExportItemList.flatfileTxt],
    },
    {
      value: EnumDownloadType.貨號文字檔下載,
      label: '貨號文字檔下載',
      show: exportItemList[EnumExportItemList.flatfileProdTxt],
    },
  ];

  return temp.filter((v) => v.show);
};

export default getOrderQueryDownloadOption;
